export default {"src":"/_next/static/media/net.6fdd6db6.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};